/*
 * @Author: cc
 * @Date: 2021-01-14 17:23:53
 * @LastEditTime: 2022-07-18 18:10:06
 * @LastEditors: Please set LastEditors
 * @FilePath: \MCN_new\app\main\submissionManage\personalLibrary\manuscriptDetails\manuscriptDetails.js
 * @Description: 首页
 */
'use strict';
angular.module('manuscriptDetailsModule', ['manuscriptDetailsRouter']).controller('manuscriptDetailsCtrl', [
    '$scope',
    'httpService',
    '$state',
    '$stateParams',
    '$sce',
    'ueditorService',
    'persinalLibraryService',
    function ($scope, httpService, $state, $stateParams, $sce, ueditorService, persinalLibraryService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                picList: [],
                platform: $stateParams.platform
            };
            $scope.listData = [];
            $scope.page = {
                CURRPAGE: 0,
                PAGESIZE: 10,
                ITEMCOUNT: 0
            };
            $scope.params = {
                id: $stateParams.id
            };
        }
        /**
         * [initStatus description] 初始化数据
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description] 初始化列表数据
         */
        function requestData() {
            $scope.loadingPromise = httpService.http('/mcnww/web/article/findById.do', $scope.params, 'get').then(function (data) {
                $scope.listData = data;
                $scope.listData.htmlContent = $sce.trustAsHtml(data.data.articleHtmlCon);
                if (data.videoUrlList && data.videoUrlList.length) {
                    persinalLibraryService.getVideoDetail(data.videoUrlList[0].audioVideoId).then(
                        (res) => {
                            $scope.status.videoUrl = res || data.videoUrlList[0].url;
                        }
                    );
                    if ($scope.status.videoUrl && $scope.status.videoUrl.split('?').length) {
                        $scope.status.videoUrl = $scope.status.videoUrl.split('?')[0];
                    }
                }
                if (data.picUrlList && data.picUrlList.length) {
                    $scope.status.picList = data.picUrlList;
                }
                ueditorService.drawVideoMark(false, true);
            });
        }
        $scope.toDetail = function (item) {
            var url = $state.href('editpage', { id: item.id, type: 6 }, { reload: 'editpage' });
            if (item.articleType === 2) {
                url = $state.href('editvideo', { id: item.id, type: 7 }, { reload: 'editvideo' });
            } else if (item.articleType === 3) {
                url = $state.href('editImage', { id: item.id, type: 8 }, { reload: 'editvideo' });
            }
            window.open(url, '_blank');
        };
    }
]);
